module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ProductSearchView.js"));
	}, "ProductSearchView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ProductSearchView!./src/pages/Shop/Product/ProductSearch/ProductSearchView.js
// module id = 844
// module chunks = 438